"use client";

import { useState } from "react";
import { site } from "@/lib/site";
import Icon from "./Icon";

const nav = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur">
      {/* Top utility bar */}
      <div className="hidden bg-navy-800 text-slate-200 md:block">
        <div className="container-px mx-auto flex max-w-7xl items-center justify-between py-2 text-sm">
          <span className="flex items-center gap-2">
            <Icon name="mapPin" className="h-4 w-4 text-brand-400" />
            Serving Bakersfield, CA & Nampa, ID
          </span>
          <span className="flex items-center gap-5">
            <span className="flex items-center gap-2">
              <Icon name="clock" className="h-4 w-4 text-brand-400" />
              {site.hours}
            </span>
            <a
              href={site.primaryPhoneHref}
              className="flex items-center gap-2 font-semibold text-white hover:text-brand-300"
            >
              <Icon name="phone" className="h-4 w-4 text-brand-400" />
              {site.primaryPhone}
            </a>
          </span>
        </div>
      </div>

      {/* Main nav */}
      <div className="container-px mx-auto flex max-w-7xl items-center justify-between py-3">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-brand-500 text-white shadow-md shadow-brand-500/30">
            <Icon name="bolt" className="h-6 w-6" />
          </span>
          <span className="leading-tight">
            <span className="block text-lg font-extrabold tracking-tight text-navy-800">
              Bronco Electric
            </span>
            <span className="block text-xs font-semibold uppercase tracking-widest text-brand-600">
              {site.tagline}
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-semibold text-navy-700 transition hover:text-brand-600"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            className="rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-bold text-white shadow-md shadow-brand-500/30 transition hover:bg-brand-600"
          >
            Request a Quote
          </a>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden"
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-slate-300 text-navy-800">
            {open ? (
              <svg viewBox="0 0 24 24" className="h-6 w-6" stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round">
                <path d="M6 6l12 12M18 6 6 18" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" className="h-6 w-6" stroke="currentColor" strokeWidth={2} fill="none" strokeLinecap="round">
                <path d="M4 7h16M4 12h16M4 17h16" />
              </svg>
            )}
          </span>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <nav className="border-t border-slate-200 bg-white lg:hidden">
          <div className="container-px mx-auto flex max-w-7xl flex-col py-3">
            {nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-slate-100 py-3 font-semibold text-navy-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href={site.primaryPhoneHref}
              className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-navy-800 px-5 py-3 font-bold text-white"
            >
              <Icon name="phone" className="h-5 w-5 text-brand-400" />
              Call {site.primaryPhone}
            </a>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-lg bg-brand-500 px-5 py-3 text-center font-bold text-white"
            >
              Request a Quote
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
